class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.closeTimeout = null;
    this.setupHoverEvents();
  }

  setupHoverEvents() {
    this.addEventListener("mouseenter", () => {
      this.cancelClose();
      this.open();
    });

    this.addEventListener("mouseleave", () => {
      this.scheduleClose();
    });

    if (this.content) {
      this.content.addEventListener("mouseenter", () => {
        this.cancelClose();
      });

      this.content.addEventListener("mouseleave", () => {
        this.scheduleClose();
      });
    }
  }

  scheduleClose() {
    this.cancelClose();
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  cancelClose() {
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
  }

  open() {
    this.mainDetailsToggle.classList.remove("mega-menu--closing");
    this.mainDetailsToggle.setAttribute("open", "");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", true);
  }

  close() {
    this.mainDetailsToggle.classList.add("mega-menu--closing");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);

    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open");
      this.mainDetailsToggle.classList.remove("mega-menu--closing");
    }, 300); 
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
